import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { BaseQuestionPreviewComponent } from '../../../bases';
import { useQuestionContext } from '../../../core';
import { AnswerItem } from './components';
import { useMemo, useState } from 'react';
import styled from '@xstyled/styled-components';
import { getSize } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledMatchingAnswersContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n\n  width: 100%;\n  margin-top: ", ";\n"])), getSize('padding8'), getSize('padding16'));
var StyledQuestionTitle = styled.label(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-size: 12px;\n  font-weight: 500;\n  color: #94a3b8;\n  line-height: 1rem;\n  text-transform: uppercase;\n"])));
export var MatchingPreviewComponent = function MatchingPreviewComponent(_ref) {
  var states = _ref.states,
      actions = _ref.actions;
  var matchingLabel = states.matchingLabel,
      isShowCorrectAnswer = states.isShowCorrectAnswer;

  var _useQuestionContext = useQuestionContext(),
      question = _useQuestionContext.question;

  var matchingQuestion = question; // State để lưu selected values cho mỗi sub question

  var _useState = useState({}),
      selectedAnswers = _useState[0],
      setSelectedAnswers = _useState[1]; // Convert answers thành options format


  var answerOptions = useMemo(function () {
    if (!matchingQuestion.answers || matchingQuestion.answers.length === 0) {
      return [];
    }

    return matchingQuestion.answers.map(function (answer) {
      return {
        value: answer.id.toString(),
        label: answer.description
      };
    });
  }, [matchingQuestion.answers]);

  var handleSelect = function handleSelect(subQuestionId, answerId) {
    setSelectedAnswers(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, subQuestionId, answerId));
    });
  }; // Fix: Simplify logic for isSelected and selectedValue


  var getSelectedValue = function getSelectedValue(subQuestionId) {
    if (isShowCorrectAnswer) {
      var correctAnswer = (matchingQuestion.correctAnswers || []).find(function (ca) {
        return ca.subQuestionId === subQuestionId;
      });
      return correctAnswer === null || correctAnswer === void 0 ? void 0 : correctAnswer.answerId;
    }

    return selectedAnswers[subQuestionId];
  };

  var getCorrectAnswerId = function getCorrectAnswerId(subQuestionId) {
    var _find;

    return (_find = (matchingQuestion.correctAnswers || []).find(function (ca) {
      return ca.subQuestionId === subQuestionId;
    })) === null || _find === void 0 ? void 0 : _find.answerId;
  };

  return /*#__PURE__*/_jsxs(BaseQuestionPreviewComponent, {
    states: states,
    actions: actions,
    children: [/*#__PURE__*/_jsx(StyledQuestionTitle, {
      children: matchingLabel.answers
    }), matchingQuestion.subQuestions && matchingQuestion.subQuestions.length > 0 && /*#__PURE__*/_jsx(StyledMatchingAnswersContainer, {
      children: matchingQuestion.subQuestions.map(function (subQuestion, index) {
        var displayIndex = (question.index || 1) + index;
        return /*#__PURE__*/_jsx(AnswerItem, {
          index: displayIndex,
          isSelected: !!selectedAnswers[subQuestion.id.toString()],
          readonly: states.readonly,
          subQuestionDescription: subQuestion.description,
          selectedValue: getSelectedValue(subQuestion.id.toString()),
          onSelect: function onSelect(value) {
            return handleSelect(subQuestion.id.toString(), value);
          },
          options: answerOptions,
          isShowCorrectAnswer: isShowCorrectAnswer,
          correctAnswerId: getCorrectAnswerId(subQuestion.id.toString())
        }, subQuestion.id.toString());
      })
    })]
  });
};